import { Entrypoints } from 'core/app/entrypoints';

import { PCCache } from 'data/PCCache';

import { LogEvent, LogEventOptions } from 'data/models/LogEvent';
import { PortCall } from 'data/models/PortCall';

import { LogUpdater, LogUpdaterParams } from 'portcall/eventlog/logupdater';

// TH: This replaces the old PortCallProfile_LogRefreshRate Web.config setting.
// There was no reason that setting needed to be in Web.config, and this makes the LogUpdater more self-contained.
// TODO: May wanna make this a parameter to the LogUpdater. Really whether to poll and how often depends on parent context.
const LOG_REFRESH_SECONDS = 20;

export interface PortCallLogUpdaterParams {
    portcall : PortCall;
}

export type PortCallLogUpdater = ReturnType<typeof PortCallLogUpdater>;

// Utility for auto-updating the portcalllog component.
// Construct LogUpdater in your parent view and pass it into the portcalllog component.
// NOTE: Important -- please dispose the LogUpdater from your parent view. The portcalllog component does NOT dispose the LogUpdater automatically.
// Rule of thumb - whichever component constructs the LogUpdater should also dispose it.
export function PortCallLogUpdater(
    entrypoints : Entrypoints,
    data : PCCache,
    logUpdaterModel : (params : LogUpdaterParams<LogEvent, LogEventOptions>) => LogUpdater,
    { portcall } : PortCallLogUpdaterParams
) {
    return logUpdaterModel({
        collection: data.LogEvents,
        url: ({ NeedSince }) => entrypoints.ViewLogEvents({ Id: portcall.Id(), NeedSince }),
        refreshSeconds: LOG_REFRESH_SECONDS
    });
}



// WEBPACK FOOTER //
// ./apps/portcall/portcalllog/logupdater.ts